import Image from 'next/image'

import generateBlurDataURL from '@/helpers/generateBlurDataURL'
import { AvatarProps } from '@/views/creator/ts'

function Avatar({ nickname, src }: AvatarProps) {
  const blur = generateBlurDataURL(256, 256)

  return (
    <figure
      className="relative flex-shrink-0 w-24 h-24 overflow-hidden border-4 rounded-full 2md:w-40 2md:h-40 lg:w-64 lg:h-64 border-gray-20"
      style={{ gridArea: 'avatar' }}
    >
      <Image
        alt={nickname}
        src={src.replace(/\/([^/]+)$/, '/cover_$1')}
        layout="fill"
        objectFit="cover"
        priority
        placeholder="blur"
        blurDataURL={blur}
        quality={75}
        loading="eager"
      />
    </figure>
  )
}

export default Avatar
